export enum ReportAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    ADD_EMPLOYEE_LIST = "ADD_EMPLOYEE_LIST",
    UPDATE_EMPLOYEE_LIST = "UPDATE_EMPLOYEE_LIST",
    UPDATE_EMPLOYEE_SEARCH_REQ = "UPDATE_EMPLOYEE_SEARCH_REQ",
    UPDATE_TEAM_LIST = "UPDATE_TEAM_LIST",
}